module.exports = __webpack_public_path__ + "img/Store1.f750698d.jpg";